import { render, staticRenderFns } from "./BundleProduct.vue?vue&type=template&id=b2beaf62&scoped=true"
import script from "./BundleProduct.vue?vue&type=script&lang=js"
export * from "./BundleProduct.vue?vue&type=script&lang=js"
import style0 from "./BundleProduct.vue?vue&type=style&index=0&id=b2beaf62&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2beaf62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2beaf62')) {
      api.createRecord('b2beaf62', component.options)
    } else {
      api.reload('b2beaf62', component.options)
    }
    module.hot.accept("./BundleProduct.vue?vue&type=template&id=b2beaf62&scoped=true", function () {
      api.rerender('b2beaf62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/bundles/BundleProduct.vue"
export default component.exports